import language from '../language'

const stages = [
  'initiated',
  'blocked',
  'voided',
  'declined',
  'successful',
  'refund'
]

const stagesNames = {
  INITIATED: 'initiated',
  BLOCKED: 'blocked',
  VOIDED: 'voided',
  DECLINED: 'declined',
  SUCCESSFUL: 'successful',
  REFUND: 'refund'
} as const

export type PaymentStageNamesTypes = typeof stagesNames[keyof typeof stagesNames]

const GREEN = 'green'
const RED = 'red'
const DEFAULT_COLOR = RED
const DEFAULT_PERCENT_OF = 'Initiated'

const stageConfig = {
  initiated: addDefaults({
    percentColor: GREEN,
    showPercentage: false,
    showMethodTab: false,
    showProviderTab: false,
    translations: {
      label: language.flow.label.initiated,
      description: language.flow.description.initiated
    }
  }),
  blocked: addDefaults({
    showPercentage: false,
    hasParenthesis: true,
    showProviderTab: false,
    translations: {
      label: language.flow.label.blocked,
      description: language.flow.description.blocked
    }
  }),
  voided: addDefaults({
    showPercentage: false,
    hasParenthesis: true,
    translations: {
      label: language.flow.label.voided,
      description: language.flow.description.voided
    }
  }),
  declined: addDefaults({
    showPercentage: false,
    hasParenthesis: true,
    translations: {
      label: language.flow.label.declined,
      description: language.flow.description.declined
    }
  }),
  successful: addDefaults({
    showPercentage: false,
    percentColor: GREEN,
    translations: {
      label: language.flow.label.successful,
      description: language.flow.description.successful
    }
  }),
  refund: addDefaults({
    showPercentage: false,
    percentOf: ' Successful',
    hasParenthesis: true,
    translations: {
      label: language.flow.label.refund,
      description: language.flow.description.refund
    }
  })
}

function addDefaults ({
  description = '',
  percentOf = DEFAULT_PERCENT_OF,
  hasParenthesis = false,
  percentColor = RED,
  showPercentage = true,
  showCurrencyTab = true,
  showMethodTab = true,
  showProviderTab = true,
  ...rest
}) {
  return {
    description,
    percentOf,
    hasParenthesis,
    percentColor,
    showPercentage,
    showCurrencyTab,
    showMethodTab,
    showProviderTab,
    ...rest
  }
}

export {
  stages,
  stageConfig,
  DEFAULT_COLOR,
  DEFAULT_PERCENT_OF,
  stagesNames
}
